import AIAPIService from '@/modules/ai/services/apiService'

export default class AIModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.aiService = new AIAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/ai',
        name: 'AIAgentView',
        component: () => import('@/modules/ai/views/agentView.vue'),
        meta: {
          requiresAuth: true,
          hideBreadcrumbs: true,
          title: 'Synergy AI',
          menuLink: '/ai',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ]
        }
      },
      {
        path: '/ai/configuration',
        name: 'AIConfigurationView',
        component: () => import('@/modules/ai/views/aiConfiguration.vue'),
        meta: {
          requiresAuth: true,
          hideBreadcrumbs: true,
          title: 'AI Configuration',
          menuLink: '/ai/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ]
        }
      }
    ]
  }
}